import TelemetryButton from "@/design-system/telemetry-button";
import { CbTopBaseResources } from "@/src/cashback/LandingPage/Version/cb-top-base.Resources";
import { CbTopBaseResourcesEn } from "@/src/cashback/LandingPage/Version/cb-top-base.Resources.En";
import { SocialProof } from "@/src/cashback/LandingPage/Version/social-proof";
import { LoginModalView, useActiveLoginModalContext, useViewportInfoContext } from "@/src/contexts";
import { languageSelector } from "@/src/contexts/UserAuthenticationContext";
import PanelSection from "@/src/shared/panel-section";

import bgImg from "./../_assets/bg_hero_right.jpg";
import bgImgMobile from "./../_assets/bg_hero_right_mobile.jpg";

import * as css from "./../../CashbackTopSection.module.css";
import * as versionCss from "./lpVersionE.module.css";

export function LpTopComponentVersionE() {
    const ME_VERISON = "E";

    const resources = languageSelector(CbTopBaseResources, CbTopBaseResourcesEn);

    const { setActiveLoginModal } = useActiveLoginModalContext();
    const { isMobile } = useViewportInfoContext();

    const openRegistration = () => setActiveLoginModal(LoginModalView.Registration);

    return (
        <PanelSection
            telemetryCustom={{
                eventName: "cshbck-TopSection",
                actionType: "View",
                param1: ME_VERISON,
            }}
            className={versionCss.lpVersionE}
            initialInView
        >
            <div className={css.cashbackTopSectionComponent}>
                <div className={css.textContent}>
                    <h1 className={css.subject} dangerouslySetInnerHTML={{ __html: resources.title }} />

                    <SocialProof />

                    <TelemetryButton
                        as="button"
                        variant="magentaRound"
                        size={isMobile ? "M" : "L"}
                        eventName="cshbck-topSectionRegister"
                        param1={ME_VERISON}
                        onClick={openRegistration}
                    >
                        {resources.registerText}
                    </TelemetryButton>
                </div>
            </div>
            <img src={isMobile ? bgImgMobile : bgImg} className={versionCss.bgHero} />
        </PanelSection>
    );
}
